/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Hardware_4Inputs */

const en_svr_guidance_hardware_4 = /** @type {(inputs: Svr_Guidance_Hardware_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the part was left on site: exact location in building`)
};

const ja_svr_guidance_hardware_4 = /** @type {(inputs: Svr_Guidance_Hardware_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品を現場に残した場合：建物内の正確な場所`)
};

const fr_svr_guidance_hardware_4 = /** @type {(inputs: Svr_Guidance_Hardware_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si la pièce est restée sur site : emplacement exact dans le bâtiment`)
};

const de_svr_guidance_hardware_4 = /** @type {(inputs: Svr_Guidance_Hardware_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn das Teil vor Ort geblieben ist: genauer Standort im Gebäude`)
};

/**
* | output |
* | --- |
* | "If the part was left on site: exact location in building" |
*
* @param {Svr_Guidance_Hardware_4Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_hardware_4 = /** @type {((inputs?: Svr_Guidance_Hardware_4Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Hardware_4Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_hardware_4(inputs)
	if (locale === "ja") return ja_svr_guidance_hardware_4(inputs)
	if (locale === "fr") return fr_svr_guidance_hardware_4(inputs)
	return de_svr_guidance_hardware_4(inputs)
});